import $ from "jquery";
import { modal } from "./modal";
export const toggle = (collapsible) => {
    collapsible
        .closest("[data-collapse-parent]")
        .find(".collapsible")
        .not(collapsible)
        .toArray()
        .forEach((c) => hide($(c)));
    setTimeout(() => collapsible.hasClass("collapsible-visible")
        ? hide(collapsible)
        : show(collapsible));
};
export const show = (collapsible) => {
    collapsible
        .find("input, button, a")
        .toArray()
        .forEach((i) => {
        const input = $(i);
        const tabIndex = input.data("collapsible-tab-index");
        input.removeData("collapsible-tab-index");
        input.prop("tabIndex", tabIndex);
    });
    collapsible
        .addClass("collapsible-visible")
        .attr("aria-expanded", "true")
        .prop("inert", false);
};
export const hide = (collapsible) => {
    collapsible
        .find("input, button, a")
        .toArray()
        .forEach((i) => {
        const input = $(i);
        input.data("collapsible-tab-index", input.prop("tabIndex"));
        input.prop("tabIndex", "-1");
    });
    collapsible
        .removeClass("collapsible-visible")
        .attr("aria-expanded", "false")
        .prop("inert", true);
};
$(document).on("click", "[data-collapse-target]", (e) => {
    if ($(e.target).parents("[data-collapsible-ignore]").length > 0)
        return;
    toggle($($(e.currentTarget).data("collapse-target")));
});
const initialise = (container) => $(container)
    .find(".collapsible")
    .toArray()
    .forEach((c) => {
    const collapsible = $(c);
    collapsible.hasClass("collapsible-visible")
        ? show(collapsible)
        : hide(collapsible);
});
$(() => setTimeout(() => initialise(document)));
modal.on("show", (modal) => initialise(modal));
